export const roles = {
    1: ['__all'],
    2: ['dashboard', 'user_profile', 'user_cinema/address', 'user_cinema/rooms', 'user_movies'],
    3: ['dashboard', 'user_profile', 'reports/kdm', 'distributor_movies', 'distributor_movie/add', 'kdm'],
    4: ['dashboard', 'user_profile', 'user_movies', 'user_cinema/addresses', 'user_cinema/rooms'],
};
